"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWithinDeleteTimeLimit = void 0;
var ASSET_DELETE_DAYS_LIMIT = Number(process.env.ASSET_DELETE_DAYS_LIMIT || 7);
/**
 * Decides if a time overcome the asset day limit time to delete.
 */
function isWithinDeleteTimeLimit(createdTime) {
    var assetCreationDate = new Date(createdTime).getTime();
    var now = Date.now();
    var timeDiff = now - assetCreationDate;
    return timeDiff < ASSET_DELETE_DAYS_LIMIT * 24 * 60 * 60 * 1000;
}
exports.isWithinDeleteTimeLimit = isWithinDeleteTimeLimit;
